import { checkDappMobile } from '@/shared/helpers/browser'
import { naclSignAndConvertToBs58 } from '@/shared/helpers/crypto'
import { checkLocalStorage, getLocalStorage, setLocalStorage } from '@/shared/helpers/localStorage'
import { PublicKey } from '@solana/web3.js'
import nacl from 'tweetnacl'

export function createDeviceInfo() {
  let deviceInfo = null
  const browser = window ? checkDappMobile(window) : null

  if (!checkLocalStorage('godefi:deviceInfo')) {
    const keypair = nacl.sign.keyPair()
    const deviceId = new PublicKey(keypair.publicKey)
    const deviceIdSignature = naclSignAndConvertToBs58({ data: deviceId.toBase58(), secret: keypair.secretKey })
    deviceInfo = {
      deviceId: deviceId.toBase58(),
      deviceIdSignature,
    }
    setLocalStorage('godefi:deviceInfo', JSON.stringify(deviceInfo))
  } else {
    deviceInfo = JSON.parse(getLocalStorage('godefi:deviceInfo'))
  }

  return {
    deviceInfo,
    headers: {
      'Go-Defi-Device-Id': deviceInfo.deviceId,
      'Go-Defi-Device-Id-Signature': deviceInfo.deviceIdSignature,
      'Go-Defi-User-Agent': browser.isDapp ? 'EMBEDDED_BROWSER' : window.navigator.userAgent,
    },
  }
}
